var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationManagementCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#276EF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.5H14.25V17H15.75V15.5H21.75V17H23.25V15.2188C23.25 14.5625 22.6875 14 22.0312 14H15.75V12H17C17.5312 12 18 11.5625 18 11V8C18 7.46875 17.5312 7 17 7H13C12.4375 7 12 7.46875 12 8V11C12 11.2812 12.0938 11.5312 12.2812 11.7188C12.4688 11.9062 12.7188 12 13 12H14.25V14H7.9375C7.28125 14 6.75 14.5625 6.75 15.2188V17H8.25V15.5ZM13.5 10.5V8.5H16.5V10.5H13.5ZM24 18H21C20.4375 18 20 18.4688 20 19V22C20 22.5625 20.4375 23 21 23H24C24.5312 23 25 22.5625 25 22V19C25 18.4688 24.5312 18 24 18ZM23.5 21.5H21.5V19.5H23.5V21.5ZM16.5 18H13.5C12.9375 18 12.5 18.4688 12.5 19V22C12.5 22.5625 12.9375 23 13.5 23H16.5C17.0312 23 17.5 22.5625 17.5 22V19C17.5 18.4688 17.0312 18 16.5 18ZM16 21.5H14V19.5H16V21.5ZM9 18H6C5.4375 18 5 18.4688 5 19V22C5 22.5625 5.4375 23 6 23H9C9.53125 23 10 22.5625 10 22V19C10 18.4688 9.53125 18 9 18ZM8.5 21.5H6.5V19.5H8.5V21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationManagementCircle);
export default __webpack_public_path__ + "static/media/organization-management-circle.70705e5dc19022fefe0c4fe5402a659d.svg";
export { ForwardRef as ReactComponent };